import { render, staticRenderFns } from "./SummaryCollapse.vue?vue&type=template&id=731e9a66&scoped=true&"
import script from "./SummaryCollapse.vue?vue&type=script&lang=js&"
export * from "./SummaryCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCollapse.vue?vue&type=style&index=0&id=731e9a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e9a66",
  null
  
)

export default component.exports